//color codes
export const BASE_COLOR = "#8fd4e6";